import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getStudentAssignmentsService } from "@/service/dashboard.service";
import { StudentAssignmentData } from "@/types/assignment.model";
import { RootState } from "../index";

interface StudentAssignmentsState {
  data: StudentAssignmentData | null;
  loading: boolean;
  error: string | null;
  currentPage: number;
  pageSize: number;
}

const initialState: StudentAssignmentsState = {
  data: null,
  loading: false,
  error: null,
  currentPage: 1,
  pageSize: 10,
};

export const fetchStudentAssignments = createAsyncThunk(
  "studentAssignments/fetchData",
  async ({ page = 1, pageSize = 10 }: { page?: number; pageSize?: number } = {}) => {
    const response = await getStudentAssignmentsService(page, pageSize);
    return response.data;
  }
);

const studentAssignmentsSlice = createSlice({
  name: "studentAssignments",
  initialState,
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchStudentAssignments.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStudentAssignments.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
      })
      .addCase(fetchStudentAssignments.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch student assignments";
      });
  },
});

// Actions
export const { setCurrentPage, setPageSize } = studentAssignmentsSlice.actions;

// Selectors
export const selectStudentAssignments = (state: RootState) => state.studentAssignments.data;
export const selectStudentAssignmentsLoading = (state: RootState) => state.studentAssignments.loading;
export const selectStudentAssignmentsError = (state: RootState) => state.studentAssignments.error;
export const selectCurrentPage = (state: RootState) => state.studentAssignments.currentPage;
export const selectPageSize = (state: RootState) => state.studentAssignments.pageSize;

export default studentAssignmentsSlice.reducer;
